(function () {
  function setupBlock(container, button) {
    const breakEl = container.querySelector('[data-readmore-break]');
    let rest;

    if (breakEl) {
      // ✅ Manual break detected
      rest = document.createElement('div');
      rest.className = 'tag-seo__rest';
      let n = breakEl.nextSibling;
      while (n) {
        const next = n.nextSibling;
        rest.appendChild(n);
        n = next;
      }
      breakEl.remove();
      container.appendChild(rest);
      button.hidden = false;

    } else {
      // ✅ No manual break → fallback to splitting after the first block-level element
      const children = Array.from(container.children);
      if (children.length > 1) {
        rest = document.createElement('div');
        rest.className = 'tag-seo__rest';

        // Move all children after the first into rest
        for (let i = 1; i < children.length; i++) {
          rest.appendChild(children[i]);
        }

        container.appendChild(rest);
        button.hidden = false;
      } else {
        // Nothing to split, hide button
        button.hidden = true;
      }
    }

    // Toggle handler
    button.addEventListener('click', function () {
      const expanded = container.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? 'Read less' : 'Read more';
    });
  }

  function init() {
    document.querySelectorAll('.tag-seo').forEach(function (wrap) {
      const c = wrap.querySelector('.tag-seo__content');
      const b = wrap.querySelector('.tag-seo__toggle');
      if (c && b) setupBlock(c, b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
